import React from "react";

import { CompareToggleButton } from "QuotePage/Components/Compare";

import BodyText from "Common/BodyText";
import Header from "Cobalt/Header";
import Icon from "Common/Icon";
import { Card, CardHeader, CardSection } from "Theme/Card";

import makeBem from "Utils/makeBem";

const bem = makeBem("QuotePagePlanCard");

export const NoFavoritePlans = () => {
  return (
    <>
      <Header level={7}>You haven't added any plans to your favorites list yet</Header>
      <BodyText mb={4}>
        To indicate a favorite, click on the &nbsp;
        <Icon icon="heart" flavor="regular" size="lg" style={{ color: "grey" }} />
        &nbsp; from the list of plans (as seen in the example below)
      </BodyText>
      <NoFavoritePlansCard />
    </>
  );
};

const NoFavoritePlansCard = () => (
  <Card className={bem()}>
    <CardHeader p={3} className={bem("Header")}>
      <BodyText className={bem("favoriteExample")}>
        <Icon icon="heart" flavor="regular" size="lg" />
      </BodyText>
      <CompareToggleButton disabled planId={null} checked={null} />
    </CardHeader>
    <CardSection p={4} className={bem("Summary")}>
      <svg xmlns="http://www.w3.org/2000/svg" width="99" height="46" viewBox="0 0 99 46" fill="none">
        <rect width="99" height="46" rx="8" fill="#EEEEEE" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none">
        <rect width="100%" height="100%" rx="8" fill="#EEEEEE" />
      </svg>
    </CardSection>
  </Card>
);
